import {Button, IconButton, InputAdornment} from "@mui/material";
import {Popover} from "../../../../misc/Popover";
import {HelpOutline} from "@mui/icons-material";
import React, {useState} from "react";

export function ProductCodeHelp() {
    const [anchorEl, setAnchorEl] = useState<any>()

    return (
        <InputAdornment position="end">
            <IconButton onMouseOver={e => setAnchorEl(e.currentTarget)}>
                <HelpOutline />
            </IconButton>
            {anchorEl && <Popover open={true}
                     anchorEl={anchorEl}
                     onClose={() => setAnchorEl(null)}
                     anchorOrigin={{
                         vertical: 'top',
                         horizontal: 'left',
                     }}
                     transformOrigin={{
                         vertical: 'bottom',
                         horizontal: 'left',
                     }}
            >
                <div style={{padding: 16}}>
                    <b>Dynamic Product Code</b>
                    <div>
                        <p><b>{"{length}"}</b> will inject the length dimension after rounding is applied</p>
                        <p><b>{"{width:inches}"}</b> will inject the width dimension but will first convert the dimension to inches</p>
                        <p><b>{"{height:mm}"}</b> will inject the width dimension but will first convert the dimension to mm</p>
                        <p><b>{"{hand}"}</b> will inject the handing of the door the product is mounted to</p>
                        <p><b>{"{c.my_handing}"}</b> will inject the result of script my_handing</p>
                        <p><b>{"{c.my_handing:inches}"}</b> will inject the result of script my_handing formatted as inches</p>

                        <div>You can choose any of the following units:</div>
                        <ul>
                            <li>inches (or "in")</li>
                            <li>feet (or "ft")</li>
                            <li>m (for meters)</li>
                            <li>cm</li>
                            <li>mm</li>
                        </ul>
                    </div>

                    <Button onClick={() => setAnchorEl(null)}>Close</Button>
                </div>
            </Popover>}
        </InputAdornment>
    )
}